module.exports = __webpack_public_path__ + "img/cover-default.3a7b7834.webp";